/* eslint no-unused-vars: off, no-console: off */

export function sum(set) {
  if (set.length == 0) {
    return 0;
  }
  return set.reduce((acc, curr) => acc + curr);
}

export function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export function ajax(uri, cb) {
  var oReq = new XMLHttpRequest();
  oReq.addEventListener("load", function () {
    try {
      var json = JSON.parse(this.responseText);
    } catch (e) {
      console.error(e, `Response text: ${this.responseText}`)
      return;
    }
    cb(json);
  });
  oReq.open("GET", uri);
  oReq.send();
}

export function ajaxRaw(uri, cb) {
  var oReq = new XMLHttpRequest();
  oReq.addEventListener("load", function () {
    cb(this.responseText);
  });
  oReq.open("GET", uri);
  oReq.send();
}

export function* getObjectProperties(object) {
  for (var prop in object) {
    if (object.hasOwnProperty(prop)) {
      yield prop;
    }
  }
}

export function packUriParams(paramsObject) {
  var params = [];
  var props = getObjectProperties(paramsObject);
  var next, prop;
  for (next = props.next(); next.done == false; next = props.next()) {
    prop = next.value;
    params.push(encodeURIComponent(prop) + "=" + encodeURIComponent(paramsObject[prop]));
  }
  return params.join('&');
}

export function buildGetRequestUri(uri, paramsObject) {
  return uri + '?' + packUriParams(paramsObject);
}

export function randomIndex(array) {
  return Math.floor(Math.random() * array.length);
}

export function randomChoice(choices) {
  return choices[randomIndex(choices)];
}

export function* getLines(data) {
  var buffer = '';
  for (var c = 0; c < data.length; c++) {
    var char = data[c];
    if (char == '\n') {
      if (buffer) yield buffer;
      buffer = '';
      continue;
    }
    buffer += char;
  }
  if (buffer) yield buffer;
}

export function shuffle(array) {
  var shuffledArray = [];
  for (let element of array) {
    var insertIndex = Math.floor(Math.random() * shuffledArray.length);
    shuffledArray.splice(insertIndex, 0, element);
  }
  return shuffledArray;
}

export function getMinElement(elements, proxy) {
  var minValue = Infinity;
  var minElement = null;
  for (let element of elements) {
    var value = proxy[element];
    if (value < minValue) {
      minValue = value;
      minElement = element;
    }
  }
  return minElement;
}